import React, { useEffect, useState } from "react";
import { Dropdown } from "Common/Components/Dropdown";
import { Link } from "react-router-dom";
import {
  Eye,
  FileEdit,
  Heart,
  MoreHorizontal,
  ShoppingCart,
  Trash2,
} from "lucide-react";
import { useDispatch } from "react-redux";
import { setIsEditing } from "slices/jewellery/reducer";
import {
  PriceResponse,
  useJewelleryContext,
} from "context/JwelleryPriceContext";
// import { countDiamondPrices } from "slices/thunk";
import { countDiamondPrices } from "helpers/backend_helper";
import { AxiosResponse } from "axios";

interface JewelleryProductProps {
  item: any;
  // key: number;
  onClickDelete: (item: any) => void;
}

const JewelleryProduct: React.FC<JewelleryProductProps> = ({
  item,
  // key,
  onClickDelete,
}) => {
  const dispatch = useDispatch<any>();
  const [price, setPrice] = useState<PriceResponse[]>([]); // State for price

  const { handleJewelleryPrice, getDiamondPrices } = useJewelleryContext();

  const btnFav = (ele: any) => {
    if (ele.closest("a").classList.contains("active")) {
      ele.closest("a").classList.remove("active");
    } else {
      ele.closest("a").classList.add("active");
    }
  };

  const mainDiamond = {
    id: "main-stone",
    carat: 1,
    color: "DEF",
    clarity: "VVS",
    shape: item?.shape, // Using product shape
    pieces: 1,
  };

  const diamondsWithMain: any = [mainDiamond, ...item?.diamonds];

  // const mainDiamond = {
  //   id: "main-stone",
  //   carat: 1,
  //   color: "DEF",
  //   clarity: "VVS",
  //   shape: item?.shape, // Using product shape
  //   pieces: 1,
  // };

  // const diamondsWithMain: any = [mainDiamond, ...item?.diamonds];

  // useEffect(() => {
  //   if (diamondsWithMain) {
  //   (async () => {
  //     const response: any = await getDiamondPrices(diamondsWithMain);
  //     setPrice(response);
  //   })();
  // }
  // }, []);

  // Calculate the combined price
  const totalJewelleryPrice: any = handleJewelleryPrice(
    item,
    "yellowgold",
    "18k",
    // price,
    1,
    "combined"
  );
  

  // // Calculate the final price based on the discount type
  // let finalPrice = totalJewelleryPrice;

  // // Assuming item.isDiscounted is a boolean indicating if a discount is available
  // if (item.isDiscounted) {
  //   const { type, value } = item.discount;

  //   if (type === "percentage") {
  //     finalPrice -= (totalJewelleryPrice * value) / 100; // Apply percentage discount
  //   } else if (type === "fixed") {
  //     finalPrice -= value; // Apply fixed discount
  //   }
  // }

  return (
    <div className="card md:group-[.gridView]:flex relative" key={item._id}>
      <div className="relative group-[.gridView]:static p-8 group-[.gridView]:p-5">
        <Link
          to="#!"
          className={`absolute group/item toggle-button top-6 ltr:right-6 rtl:left-6 ${
            item.isFav && "active"
          }`}
          onClick={(e) => btnFav(e.target)}
        >
          <Heart className="size-5 text-slate-400 fill-slate-200 transition-all duration-150 ease-linear dark:text-zink-200 dark:fill-zink-600 group-[.active]/item:text-red-500 dark:group-[.active]/item:text-red-500 group-[.active]/item:fill-red-200 dark:group-[.active]/item:fill-red-500/20 group-hover/item:text-red-500 dark:group-hover/item:text-red-500 group-hover/item:fill-red-200 dark:group-hover/item:fill-red-500/20" />
        </Link>
        <div className="group-[.gridView]:p-3 group-[.gridView]:bg-slate-100 dark:group-[.gridView]:bg-zink-600 group-[.gridView]:inline-block rounded-md">
          <img
            src={item.media[0]?.images[0]}
            alt=""
            className="group-[.gridView]:h-16"
          />
        </div>
      </div>
      <div className="card-body !pt-0 md:group-[.gridView]:flex group-[.gridView]:!p-5 group-[.gridView]:gap-3 group-[.gridView]:grow">
        <div className="group-[.gridView]:grow">
          <h6 className="mb-1 truncate transition-all duration-200 ease-linear text-15 hover:text-custom-500">
            <Link to="/apps-ecommerce-product-overview">{item.title}</Link>
          </h6>

          <div className="flex items-center text-slate-500 dark:text-zink-200">
            <div className="mr-1 text-yellow-500 shrink-0 text-15">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-half-line"></i>
            </div>
            ({item.ratingNumber})
          </div>
          <h5 className="mt-4 text-16">
            {
              typeof totalJewelleryPrice?.priceWithoutDiscount === "number"
                ? `$ ${totalJewelleryPrice?.priceWithoutDiscount} `
                : "$ 0" // Fallback in case combinedPrice is not a number
            }
            {item.isDiscounted && (
              <small className="font-normal line-through text-slate-500 dark:text-zink-200">
                {totalJewelleryPrice?.priceWithDiscount}
              </small>
            )}
          </h5>
        </div>

        <div className="flex items-center gap-2 mt-4 group-[.gridView]:mt-0 group-[.gridView]:self-end">
          <button
            type="button"
            className="w-full bg-white border-dashed text-slate-500 btn border-slate-500 hover:text-slate-500 hover:bg-slate-50 hover:border-slate-600 focus:text-slate-600 focus:bg-slate-50 focus:border-slate-600 active:text-slate-600 active:bg-slate-50 active:border-slate-600 dark:bg-zink-700 dark:text-zink-200 dark:border-zink-400 dark:ring-zink-400/20 dark:hover:bg-zink-600 dark:hover:text-zink-100 dark:focus:bg-zink-600 dark:focus:text-zink-100 dark:active:bg-zink-600 dark:active:text-zink-100"
          >
            <ShoppingCart className="inline-block size-3 leading-none" />{" "}
            <span className="align-middle">Add to Cart</span>
          </button>
          <Dropdown className="relative float-right dropdown">
            <Dropdown.Trigger
              className="flex items-center justify-center w-[38.39px] h-[38.39px] dropdown-toggle p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"
              id="productList1"
              data-bs-toggle="dropdown"
            >
              <MoreHorizontal className="size-3" />
            </Dropdown.Trigger>
            <Dropdown.Content
              placement="right-end"
              className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md dropdown-menu min-w-[10rem] dark:bg-zink-600"
              aria-labelledby="productList1"
            >
              {/* <li>
                    <Link
                      className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                        to={`/duplicate-jewellery/${item._id}`}
                    >
                      <Copy className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                      <span className="align-middle">Duplicate</span>
                    </Link>
                  </li> */}
              <li>
                <Link
                  className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                  to={`/jewellery/${item._id}`}
                >
                  <Eye className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                  <span className="align-middle">Overview</span>
                </Link>
              </li>
              <li>
                <Link
                  className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                  to={`/update-jewellery/${item._id}`}
                  onClick={() => {
                    dispatch(setIsEditing(true));
                  }}
                >
                  <FileEdit className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                  <span className="align-middle">Edit</span>
                </Link>
              </li>
              <li>
                <Link
                  className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                  to="#!"
                  onClick={() => onClickDelete(item)}
                >
                  <Trash2 className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                  <span className="align-middle">Delete</span>
                </Link>
              </li>
            </Dropdown.Content>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default JewelleryProduct;
